<template>
   <div class="crud-wrapper">
      <crud-toolbar :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>

            <a-autocomplete-field :modalForm="ClientForm" :sm8="multiEnrollment" @onSelect="onClientSelect"
                                  allowEdit allowNew autofocus clearable label="Cliente / Tomador"
                                  modalWidth="550" placeholder="selecionar cliente" obj="client"
                                  ref="aafClient" v-model="formData.customerId" validate="required">
               <template slot="content" slot-scope="{data}">
                  <v-layout column>
                     <v-list-tile-title style="height: 22px;" v-text="data.name"></v-list-tile-title>
                     <v-list-tile-sub-title class="py-0">
                        {{data.federalId}} / Nasc.: {{data.birth? $moment(data.birth).format('DD/MM/YYYY'): "Data não definida"}}
                     </v-list-tile-sub-title>
                  </v-layout>
               </template>
            </a-autocomplete-field>

            <a-select-field :suggestions="clientData.jobs" @change="onEnrollmentSelect"
                            display-field="enrollment" label="N° Matrícula/Benefício" return-object
                            sm4 v-if="multiEnrollment" v-model="formData.selectedEnrollment"
                            validate="required"></a-select-field>
            <v-expand-transition origin="top left" v-if="formData.statusId != 0">
               <v-flex v-if="showCovenantExtraFields">
                  <v-layout row v-if="isINSS" wrap>

                     <v-layout row wrap style="background-color: #ffffff; border-radius: 8px; margin: 0 12px 20px 12px;" v-if="formData.benefitTypeId == 32 || clientData.age >= 78">
                        <v-flex xs12>
                           <label class="subheading grey--text">Alerta</label><br/>
                           <label style="color: #ecae00; font-weight: bold;" v-if="formData.benefitTypeId == 32">- Cliente com benefício Aposentadoria por Invalidez Previdenciária (LOPS)<br/></label>
                           <label style="color: #ecae00; font-weight: bold;" v-if="clientData.age >= 78">- Cliente com mais de 78 anos de idade </label>
                        </v-flex>
                     </v-layout>

                     <a-text-field sm8 :validate="isRequired" label="Espécie" mask="###" v-model="formData.selectedEnrollment.benefitTypeId"></a-text-field>
                     <v-flex style="padding-top: 0;" sm4>
                        <v-btn style="width: 100%; height: 52px; margin: 5px 0 0 0;" v-on:click="getFormalizationLink()">Link de Assinatura</v-btn>
                     </v-flex>
                     <v-flex sm12 style="padding-top: 0; padding-bottom: 0;" v-if="formData.formalizationLink">
                        <p style="display: flex; justify-content: center; float: right; color: black; margin-top: -20px;">{{ formData.formalizationLink }} 
                           <v-icon size="small" color="#4a4a4a" class="ml-1" v-on:click="copyText(formData.formalizationLink, $event);">fas fa-copy</v-icon>
                        </p>
                     </v-flex>
                     <a-select-field :suggestions="inssPayMethod" @change="inssPayChange"
                                     label="Forma de Pagamento" sm6 v-model="formData.paymtType"
                                     validate="required"></a-select-field>
                     <v-flex class="caption grey--text py-1" sm6 xs12>
                        <v-flex class="outlined" xs12 style="max-height: 56px; border-radius:8px;">
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 1 && !askAcct">
                              Pagamento ocorrerá na <b>conta salário</b> que está informada no cadastro do cliente.
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 1 && askAcct">
                              <span class="font-weight-bold red--text">Conta salário não cadastrada</span> para o cliente.
                              Completar as informações abaixo.
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === 2">
                              Se informar apenas banco e agência o pgto ocorrerá via <b>Ordem de Pagamento</b>
                           </label>
                           <label class="aLabel text-xs-center" v-if="formData.paymtType === null">
                              Escolha a forma de pagamento ao lado
                           </label>
                        </v-flex>
                     </v-flex>
                  </v-layout>

                  <v-layout row v-else-if="isSIAPE" wrap>
                     <a-text-field :validate="isRequired" label="UPAG" sm6
                                   v-model="formData.selectedEnrollment.upag"></a-text-field>
                     <a-text-field :validate="isRequired" label="Senha SIGEPE" sm6
                                   v-model="formData.selectedEnrollment.portalPin"></a-text-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <a-date-field label="Data de Cadastro" dateFormat="DD/MM/YYYY"
                          sm4 v-model="formData.createdAt"></a-date-field>

            <a-date-field label="Data de Digitação" dateFormat="DD/MM/YYYY"
                          sm4 v-model="formData.issueDate"></a-date-field>

            <a-date-field label="Data de Pagamento" dateFormat="DD/MM/YYYY"
                          sm4 v-model="formData.bankPaidAt"></a-date-field>

            <a-select-field label="Convênio" obj="covenant" sm6
                            v-model="formData.covenantId" clearable></a-select-field>

            <a-autocomplete-field :validate="Boolean(formData.number) ? '' : 'required'" :disabled="Boolean(formData.number)" auto-trigger label="Tipo do Produto" obj="productType" sm6
                                  v-model="formData.typeId"></a-autocomplete-field>

            <a-select-field :validate="Boolean(formData.number) ? '' : 'required'" :disabled="Boolean(formData.number)" label="Produto" obj="products" sm12 :filter-by="{product_type_id: formData.typeId}" updateWithFilters
                                  v-model="formData.productId"></a-select-field>

            <a-autocomplete-field :disabled="Boolean(formData.number || formData.productId)" sm7 validate="required" autoTrigger label="Banco do Contrato" obj="bank"
                                  v-model="formData.bankId" @onSelect="onBankSelect">
               <template slot="content" slot-scope="{data}">
                  {{`${data.bankNo} - ${data.name}`}}
               </template>
            </a-autocomplete-field>

            <a-text-field :disabled="Boolean(formData.number)" label="Nº do Contrato" sm5 v-model="formData.number"></a-text-field>

            <a-text-field v-if="formData.bankId != null" auto-trigger label="Código da Tabela" sm5 @change="onChangeBankChartCode"
                                  v-model="formData.bankChartCode"></a-text-field>

            <a-autocomplete-field auto-trigger label="Situação" obj="contractStatus"
                                  sm7 v-model="formData.statusId" validate="required"></a-autocomplete-field>

            <a-date-field disabled label="Data da Situação" dateFormat="DD/MM/YYYY"
                          sm5 v-model="formData.statusIdAt"></a-date-field>

            <v-expand-transition origin="top left">
               <v-flex xs12>
                  <div style="background-color: #ffffff; border-radius: 8px; display: flex; flex-direction: row;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Status no Banco {{formData.bankNotes ? `(${formData.bankNotes})` : ''}}</label><br/>
                        <label v-if="formData.bankStatus" :class="!([12,13,14,19,28,53].includes(formData.statusId)) ? 'red-text' : 'normal-text'">{{ formData.bankStatus }}</label>
                        <label v-else class="red-text">Contrato sem status</label>
                        <v-tooltip v-if="formData.bankStatusAt" bottom>
                           <label style="color: #262626; font-weight: bold;" slot="activator">({{ $moment(formData.bankStatusAt).fromNow() }})</label>
                           <label style="font-weight: bold;">{{ $moment(formData.bankStatusAt).format('DD/MM/YYYY HH:mm') }}</label>
                        </v-tooltip>
                     </v-flex>
                     <div class="sync-box" v-on:click="syncContract()" v-if="formData.kind != 'OPT'">
                        <v-icon :class="loadingStatusSync ? 'spinning' : ''">sync</v-icon>
                     </div>
                  </div>
               </v-flex>
            </v-expand-transition>

            <v-expand-transition origin="top left" v-if="formData.apiError">
               <v-flex xs12>
                  <div row wrap style="background-color: #ffffff; border-radius: 8px; margin-bottom: 10px;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Críticas da API do Banco</label><br/>
                        <label style="color: #e94343; font-weight: bold;">Erro: {{ formData.apiError.status }} | em {{ formData.apiError.statusAt }}</label><br/>
                        <label style="color: #262626;">- {{ formData.apiError.message }}</label>
                     </v-flex>
                  </div>
               </v-flex>
            </v-expand-transition>

            <v-expand-transition origin="top left">
               <v-flex v-if="askLastCTT" xs12>
                  <v-layout row wrap>
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Dados do Contrato Anterior</label>
                     </v-flex>
                     <v-expand-transition origin="top left">
                        <a-autocomplete-field :validate="isRequired" autoTrigger label="Banco"
                                              obj="bank" v-if="isPORTAB" v-model="formData.originalCttData.bankId">
                           <template slot="content" slot-scope="{data}">
                              {{`${data.bankNo} - ${data.name}`}}
                           </template>
                        </a-autocomplete-field>
                     </v-expand-transition>

                     <a-text-field label="N° Contrato" sm4
                                   v-model="formData.originalCttData.number"></a-text-field>
                     <a-number-field :validate="isRequired" label="Valor da Parcela" number-mask="fixed_rs"
                                     sm4 v-model="formData.originalCttData.installment"></a-number-field>
                     <a-text-field :validate="isRequired" hint="(prazo)" label="Restante" mask="###" sm4
                                   v-if="isPORTAB" v-model="formData.originalCttData.remaining"></a-text-field>
                     <a-number-field :validate="isGtZero" label="Saldo Devedor" number-mask="fixed_rs"
                                     sm4 v-model="formData.originalCttData.balanceDue"></a-number-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <v-flex pb-1 v-if="askLastCTT" xs12>
               <label class="subheading grey--text">Valores do Novo Contrato</label>
            </v-flex>
            <a-number-field sm4 label="IOF"
                            number-mask="fixed_rs" v-model="formData.iofFee"></a-number-field>
            <a-number-field sm4 label="TAC"
                            number-mask="fixed_rs" v-model="formData.tacFee"></a-number-field>
            <a-number-field sm4 label="Seguro"
                            number-mask="fixed_rs" v-model="formData.insurance"></a-number-field>

            <a-number-field sm4 label="Valor da Parcela"
                            number-mask="fixed_rs" v-model="formData.fina"></a-number-field>
            <a-number-field :label="amountLabel" sm4 :validate="isGtZero" :disabled="loadingAmount" :loading="loadingAmount"
                            number-mask="fixed_rs" v-model="formData.amount"></a-number-field>
            <a-text-field :validate="isGtZero" label="Prazo Total" mask="###" sm4 v-if="!isCard"
                          v-model="formData.term"></a-text-field>
            <a-number-field label="Limite" sm4 v-if="isCard" number-mask="fixed_rs"
                          v-model="formData.cardLimit"></a-number-field>
            <a-number-field disabled label="Valor Líquido" number-mask="fixed_rs" sm4 v-if="!isCard"
                            v-model="netAmount"></a-number-field>
            <a-number-field v-model="formData.interest" label="Taxa %" numberDecimals="2"
                            number-mask="p_rs" sm4 v-if="!isCard"></a-number-field>
            <a-number-field disabled label="Valor Total" number-mask="fixed_rs" sm4 v-if="!isCard"
                            v-model="formData.finalAmount"></a-number-field>

            <a-text-field label="Link de Assinatura/Formalização" v-model="formData.formalizationLink" sm8></a-text-field>
            <v-flex style="padding-top: 0;" sm4>
               <v-btn flat style="width: 100%; height: 52px; margin: 5px 0 0 0; color: white; background: var(--primary-color-hover);" v-on:click="getFormalizationLink()">Obter Link</v-btn>
            </v-flex>

             <v-expand-transition origin="top left" v-if="formData.statusId != 0">
               <v-flex xs12>
                  <v-layout row wrap style="border-radius: 8px; margin-bottom: 10px;">
                     <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Conta para Pagamento</label>
                     </v-flex>
                     <a-autocomplete-field :validate="isRequired" @change="bankPayChange" allow-new autoTrigger label="Banco" obj="bank" sm7
                                           v-model="formData.paymtAcct.bankId">
                        <template slot="content" slot-scope="{data}">
                           {{`${data.bankNo} - ${data.name}`}}
                        </template>
                     </a-autocomplete-field>
                     <a-text-field :validate="isRequired" label="Agência" sm2 v-mask="['###X', '####-X']"
                                   v-model="formData.paymtAcct.branchNo"></a-text-field>
                     <a-text-field :validate="isRequired" label="Conta Corrente" sm3
                                   v-mask="['###-X', '####-X', '#####-X', '######-X','#######-X',
                           '########-X','#########-X','##########-X','###########-X','############-X']"
                                   v-model="formData.paymtAcct.acctNo"></a-text-field>
                     <!-- <a-text-field v-if="isBankPayCaixa" label="Operação" sm4 v-mask="['###']" v-model="formData.paymtAcct.opNo"></a-text-field> -->
                     <a-select-field sm5 label="Tipo de Conta" :suggestions="acctTypes" v-model="formData.paymtAcct.acctType"></a-select-field>
                  </v-layout>
               </v-flex>
            </v-expand-transition>

            <a-text-area-field autoGrow label="MENSAGEM VISÍVEL AO CLIENTE" v-model="formData.customerNotes"></a-text-area-field>
            <a-text-area-field autoGrow label="Observações Internas" v-model="formData.notes"></a-text-area-field>

            <v-flex pt-0 style="min-height: 40px;" xs12 v-if="contractKind === 'CTT'">
               <div class="file-content-one">
                  <div>
                     <p style="color: #030f12; font-size: 20px; margin-top: 10px; margin-left: 20px;">Proposta: {{ formData.number }}</p>
                  </div>
                  <v-btn color="#ffae00" style="font-size: 12px; color: white;">
                     Cancelar no Banco
                  </v-btn>
               </div>
            </v-flex>

         </v-layout>

         <template slot="rightContent">
            <div style="display: flex; justify-content: space-between; margin: -13px -10px 20px -10px;" v-if="formData.kind === 'CTT'">
               <v-btn flat v-on:click="setProposal('approved')" style="width: 100%; flex: auto; background: rgb(125, 182, 88); color: white;">Aprovar</v-btn>
               <!-- <v-btn v-on:click="setProposal('reproved')" style="width: 100%; flex: auto; background: red; color: white;">Reprovar</v-btn> -->
               <v-btn flat v-on:click="setProposal('cancelled')" style="width: 100%; flex: auto;">Cancelar</v-btn>
               <!-- <v-btn v-on:click="setProposal('pending')" style="width: 100%; flex: auto; background: orange; color: white;">Pendenciar</v-btn> -->
            </div>

            <div style="display: flex; justify-content: space-between; margin: -13px -10px 20px -10px;" v-if="formData.kind === 'EST'">
               <v-btn flat v-on:click="setProposal('simulation')" :loading="loadingSimulation" style="width: 100%; flex: auto; background: rgb(125, 182, 88); color: white;">Simular</v-btn>
               <v-btn flat v-on:click="dialogContract = true" style="width: 100%; flex: auto; background: rgb(51, 122, 183); color: white;">Digitar no Banco</v-btn>
            </div>

            <div v-if="formData.customerId && clientData">
               <v-slide-y-transition mt-0 origin="top center" pt-0 tag="v-layout">
                  <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat key="card1" style="margin-top: -10px; border-radius:12px;"
                  >
                     <v-card-title class="pt-2 headline" primary-title>
                        <v-flex pa-0 xs10>
                            <label @click="editClient" class="text-truncate mt-2 aLink">{{clientData.name}} (#{{clientData.id}})</label>
<!--                           <label class="text-truncate mt-2 aLink">{{clientData.name}}</label>-->
                        </v-flex>
                        <v-flex pa-0 style="height: 40px;" xs2>
                           <v-img :src="$config.imageUri(formData.selectedEnrollment.covenantLogo, 'smLogo')"
                                  contain height="40px"></v-img>
                        </v-flex>
                     </v-card-title>

                     <!--Client Data-->
                     <v-layout pt-0 px-3 row wrap>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">CPF</label>
                           <label style="display: block;">{{clientData.federalId}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Matrícula/Benefício</label>
                           <label style="display: block;">{{formData.selectedEnrollment.enrollment}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Convênio</label>
                           <label style="display: block;">{{formData.selectedEnrollment.covenantName}}</label>
                        </v-flex>

                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Nascimento</label>
                           <label style="display: block;">
                              ({{clientData.age || '?'}} anos) {{clientData.birth? $moment(clientData.birth).format('DD/MM/YYYY'): "Data não definida"}}
                           </label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Fone/Celular</label>
                           <label>{{clientData.mobileNumber}}</label><!--
                           --><a target="_blank" :href="currentWaLink" style="height: 18px; margin-left: 5px;">
                              <v-icon small>fab fa-whatsapp</v-icon>
                           </a>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Tipo</label>
                           <label style="display: block;">{{formData.selectedEnrollment.categoryName}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Número RG</label>
                           <label style="display: block;">{{clientData.rgNumber}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Órgão/UF RG</label>
                           <label style="display: block;">{{clientData.rgAgency}} / {{clientData.rgAgencyState}}</label>
                        </v-flex>
                        <v-flex pt-0 xs4>
                           <label class="v-label  theme--light aLabel">Expedição</label>
                           <label style="display: block;">{{clientData.rgIssueDate? $moment(clientData.rgIssueDate).format('DD/MM/YYYY'): "Data não definida"}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Natural de</label>
                           <label style="display: block;">{{clientData.bornCity}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs8>
                           <label class="v-label  theme--light aLabel">Email</label>
                           <label style="display: block;">{{clientData.mainEmail}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Profissão</label>
                           <label style="display: block;">{{clientData.occupation}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Cargo</label>
                           <label style="display: block;">{{clientData.office}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs4>
                           <label class="v-label  theme--light aLabel">Nome da Mãe</label>
                           <label style="display: block;">{{clientData.mother}}</label>
                        </v-flex>

                        <v-flex xs12>
                           <v-divider></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Proventos</v-subheader>
                        </v-flex>

                        <v-flex pt-0 xs12>
                           <div style="display: flex; flex-direction: row;">
                              <div>Início do Benefício:</div>
                              <span style="margin-left: 5px;">{{formData.selectedEnrollment.dib ? $moment(formData.selectedEnrollment.dib).format('DD/MM/YYYY'): "Data não encontrada"}}</span>
                           </div>
                        </v-flex>
                         <v-flex pt-0 style="min-height: 40px;" xs12>
                           <div style="display: flex; flex-direction: row;">
                              <div>Salário:</div>
                              <span style="margin-left: 5px;">{{formData.selectedEnrollment.salary | fmtMoney}}</span>
                           </div>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Margem Empréstimo</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin30 | fmtMoney}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Margem Livre</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin30Free | fmtMoney}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Fonte</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin30FreeOrigin ? formData.selectedEnrollment.margin30FreeOrigin == 'user' ? "Usuário" : "Portal" : "Nenhuma"}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Data</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin30FreeAt ? $moment(formData.selectedEnrollment.margin30FreeAt).format('DD/MM/YYYY') : "Não definida"}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Margem Cartão</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin5 | fmtMoney}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Margem Livre</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin5Free | fmtMoney}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Fonte</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin5FreeOrigin ? formData.selectedEnrollment.margin5FreeOrigin == 'user' ? "Usuário" : "Portal" : "Nenhuma"}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Data</label>
                           <label style="display: block;">{{formData.selectedEnrollment.margin5FreeAt ? $moment(formData.selectedEnrollment.margin5FreeAt).format('DD/MM/YYYY') : "Não definida"}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs3>
                           <label class="v-label  theme--light aLabel">Saldo FGTS</label>
                           <label style="display: block;">{{ getFGTSBalance | fmtMoney }}</label>
                        </v-flex>

                        <v-flex xs12>
                           <v-divider class="mb-0"></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Conta Salário</v-subheader>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs7>
                           <label class="v-label  theme--light aLabel">Banco</label>
                           <label style="display: block;">{{formData.paymtAcct.bankName}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs2>
                           <label class="v-label  theme--light aLabel">Agência</label>
                           <label style="display: block;">{{formData.paymtAcct.branchNo}}</label>
                        </v-flex>
                        <v-flex pt-0 xs3>
                           <label class="v-label  theme--light aLabel">Conta Corrente</label>
                           <label style="display: block;">{{formData.paymtAcct.acctNo}}</label>
                        </v-flex>
                        <!-- <v-flex pt-0 xs3 v-if="isBankPayCaixa && formData.paymtAcct.opNo">
                           <label class="v-label  theme--light aLabel">Operação</label>
                           <label style="display: block;">{{formData.paymtAcct.opNo}}</label>
                        </v-flex> -->
                        <v-flex pt-0 xs3>
                           <label class="v-label  theme--light aLabel">Tipo de Operação</label>
                           <label style="display: block;">{{formData.paymtAcct.acctType ? formData.paymtAcct.acctType == 'P' ? 'Conta Poupança' : 'Conta Corrente' : ''}}</label>
                        </v-flex>

                        <v-flex xs12>
                           <v-divider></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Endereço</v-subheader>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs12>
                           <label class="v-label  theme--light aLabel">Rua, número</label>
                           <label style="display: block;">{{clientData.address}}, {{clientData.addressNumber}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Complemento</label>
                           <label style="display: block;">{{clientData.address2}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Bairro</label>
                           <label style="display: block;">{{clientData.district}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">Cidade/UF</label>
                           <label style="display: block;">{{clientData.city}}/{{clientData.state}}</label>
                        </v-flex>
                        <v-flex pt-0 style="min-height: 40px;" xs6>
                           <label class="v-label  theme--light aLabel">CEP</label>
                           <label style="display: block;">{{clientData.zipcode}}</label>
                        </v-flex>

                        <v-flex pt-0 style="min-height: 40px;" xs12>
                           <v-divider></v-divider>
                           <v-subheader class="pl-0" style="height: 30px">Observações</v-subheader>

                           <label style="display: block;">{{clientData.notes}}</label>
                        </v-flex>

                     </v-layout>

                  </v-card>
               </v-slide-y-transition>

               <v-slide-y-transition mt-0 origin="top center" pt-0>
                  <v-card color="rgba(0,0,0, 0.03)" flat style="margin-top: -10px; border-radius:8px;">
                     <v-card-title class="pt-2 title" primary-title>
                        Importe aqui imagens dos documentos do cliente
                     </v-card-title>
                     <v-card-text>
                        <file-pond
                                :server="this.cloudinaryUpload(this.$config.mediaStorage.uploadUrl, this.$config.mediaStorage.presets.customer.id)"
                                accepted-file-types="image/png, image/jpeg"
                                allow-multiple="true"
                                drop-on-page="true"
                                drop-validation="true"
                                instantUpload="false"
                                label-idle="Arraste e solte arquivos* aqui, ou clique para escolher..."
                                labelButtonAbortItemProcessing="Cancelar"
                                labelButtonProcessItem="Carregar"
                                labelButtonRemoveItem="Remover"
                                labelFileProcessingComplete="Upload concluído"
                                labelFileProcessingError="Erro no upload"
                                labelTapToCancel="cancelar"
                                labelTapToRetry="tentar novamente"
                                ref="pond">
                        </file-pond>
                     </v-card-text>
                  </v-card>
               </v-slide-y-transition>

               <v-slide-y-transition origin="top center">
                     <v-card color="rgba(0,0,0, 0.03)" flat style="margin-top: 10px; border-radius: 12px; padding-bottom: 12px;">
                        <v-card-title>Documentos do Cliente</v-card-title>
                        <div class="expansion" v-on:click="toggleExpansion($event)" v-for="enrollment in formData.enrollmentsFile" :key="enrollment.enrollment">
                           <div class="expansion-header">
                              <h3>{{ enrollment.enrollment }}{{ enrollment.covenantName ? ` (${enrollment.covenantName})` : null }}</h3>
                              <v-icon small>fas fa-chevron-left</v-icon>
                           </div>
                           <div class="expansion-body">
                              <viewer :images="enrollment.file">
                                 <img style="max-height: 200px; margin: 0px 5px; border-radius: 5px;" v-for="src in enrollment.file" :src="$config.imageUri(`${src.file}.jpg`, 'photoBigger')" :key="src.file" />
                              </viewer>

                              <div class="file-content" :key="file.file" v-for="file in enrollment.filesPdf">
                                 <div>
                                    <v-icon color="#4744e9" class="ml-1">fas fa-file-pdf</v-icon>
                                    <p>{{ file.name }}</p>
                                 </div>
                                 <v-btn color="#4744e9" style="font-size: 12px; color: white;" v-on:click="openFileModal($config.imageUri(file.file, 'none'))">
                                    Ver
                                 </v-btn>
                              </div>
                           </div>
                        </div>
                     </v-card>
               </v-slide-y-transition>
            </div>
            <!-- Dialog de detalhes do contrato -->
               <v-layout row justify-center>
               <v-dialog v-model="dialogContract" persistent max-width="500">
                  <v-card style="padding: 10px">
                  <v-card-title class="headline" style="font-weight: 500;">Confirma o envio dessa proposta?</v-card-title>
                  <v-card-text style="margin-bottom: 10px;">A proposta será enviada para o <br><b>{{ getNameBank(formData.bankId) }}</b><br> conforme banco selecionado nos campos de proposta de contrato.</v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn color="gray darken-1" flat @click="dialogContract = false">Cancelar</v-btn>
                     <v-btn style="background: rgb(125, 182, 88); color: white;" @click="setProposal('add')" :loading="isLoadingProposal">Enviar Proposta</v-btn>
                  </v-card-actions>
                  </v-card>
               </v-dialog>
            </v-layout>
         </template>
      </crud-form>

      <div class="file-container" v-on:click="closeFileModal($event)" v-if="fileModalOpen">
         <v-icon class="btn-file-close" color="white" v-on:click="closeFileModal($event)">fas fa-times</v-icon>
         <iframe :src="fileSelected" frameborder="0"></iframe>
      </div>
   </div>
</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import "viewerjs/dist/viewer.css";
    import ClientForm from './ClientForm';
    import vueFilePond from 'vue-filepond';

    export default CrudFormClass.extend({
        name: 'ContractForm',

        components: {
            FilePond: vueFilePond(),
        },

        props: {
            customerId: {
                type: Number,
                required: false
            },
            kind: {
                type: String,
                required: false
            },
            statusId: {
                type: Number,
                required: false
            },
            formDataParam: {
               type: Object,
               required: false
            }
        },

        data: function () {
            return {
                title: this.$route.name !==  'Workflow' ? 'Contrato' : 'Proposta',
                formName: 'contractForm',
                aux: 0,

                ClientForm,
                covenantList: [],

                loadingStatusSync: false,

                inssPayMethod: [
                    {
                        id: 1,
                        name: 'Conta Corrente'
                    },
                    {
                        id: 2,
                        name: 'Cartão Magnético'
                    }
                ],

                acctTypes: [
                    {
                        id: "C",
                        name: "Conta Corrente",
                    },
                    {
                        id: "P",
                        name: "Conta Poupança",
                    }
                ],

                loadingSimulation: false,
                isLoadingProposal: false,
                dialogContract: false,

                toCTT: false,
                salaryBankName: null,

                auxBankPayOpNo: null,
                formalizationLink: null,

                fileModalOpen: false,
                fileSelected: null,

                loadingAmount: false,
                banks: [],

                isBankChartCodeRequired: '',
                products: [],
                filteredProducts: [],

                dialogContract: false,

                formData: Object.assign({
                    id: null,
                    offerLeadId: null,
                    simulationId: null,
                    companyId: this.$store.state.company.user.workingCo,
                    statusId: this.statusId == null ? 1 : this.statusId,
                    statusIdAt: null,
                    bankPaidAt: null,
                    covenantId: null,
                    customerId: this.customerId,
                    enrollmentId: null,
                    bankId: null,
                    productId: null,
                    typeId: 10,
                    chartId: null,
                    bankChartCode: null,
                    enrollment: null,
                    paymtType: null,
                    paymtAcct: {},
                    type: 'E', //TYPE CONTRATO
                    kind: null,
                    number: null,
                    numberField: null,
                    issueDate: null,
                    amount: 0,
                    selectedEnrollment: {},
                    installment: 0,
                    term: 0,
                    interest: 0,
                    cardAmount: 0,
                    cardLimit: 0,
                    startMonth: null,
                    endMonth: null,
                    originalCttData: {},
                    notes: null,
                    customerNotes: null,
                    statusName: null,
                    covenantName: null,
                    userName: null,
                    file: null,
                    filesPdf: null,
                    apiError: null,
                    benefitTypeId: null,
                    netAmount: null,
                    bankStatus: null,
                    bankNotes: null,
                    updatedAt: null,
                    iofFee: null,
                    insurance: null,
                    bankStatusAt: null,
                    bankLink: null,
                    createdAt: null,
                    formalizationLink: null,
                    tacFee: 0,
                    financedAmount: 0,
                    finalAmount: 0,
                }, this.formDataParam),
                clientData: {}
            };
        },

        watch: {
           'formData.id': function (value) {
               this.syncContract(true);
           },

           'formData.paymtAcct.bankId': {
               handler: async function (value) {
                  if (!this.banks.length) {
                     this.banks = await this.$api.dataService.search('bank');
                  }
                  let bankNo = this.banks.find((e) => e.id == value).bankNo;
                  let bankName = this.banks.find((e) => e.id == value).name;

                  this.formData.paymtAcct.bankNo = bankNo;
                  this.formData.paymtAcct.bankName = bankName;
               }
            },
            'formData.paymtAcct': {
                handler: function(value, oldValue) {
                    if(value === null) {
                        this.formData.paymtAcct = {};
                    }
                }
            },
            'formData.selectedEnrollment': {
               handler: function(v, oldVal) {
                  if(!this.isINSS){
                     this.formData.selectedEnrollment.benefitTypeId = null
                  }
               }
            },
            'formData.covenantId': function (value) {
               let auxCovenant = this.covenantList.find(co => co.id == value);
               if(auxCovenant){
                  this.formData.term = auxCovenant.maxTerm;
                  if(this.aux >= 2){
                     this.formData.chartId = null;
                  }else{
                     this.aux = this.aux +1;
                  }
               }
            },
            'formData.bankId': function () {
               if(this.aux >= 2){
                  this.formData.chartId = null;
               }else{
                  this.aux = this.aux +1;
               }
            },
            'formData.statusId': async function (newValue) {
                let selected = await this.$api.dataService.search('contractStatus', { id: newValue });
                if (selected) {
                    this.toCTT = (selected[0].kind !== 'EST');
                } else {
                    this.toCTT = false;
                }
            },
            'formData.customerId' (newValue) {
               if (!newValue) {
                  this.formData.paymtType = null;
                  this.formData.selectedEnrollment = {};
                  this.salaryBankName = null;
                  this.formData.paymtAcct = {};
               }
            },
            'formData.number' (value) {
               if (value) {
                  this.formData.numberField = value;
               }
            },

            'formData.productId' (value) {
               let product = this.products.find((product) => product.id == value);
               this.formData.bankChartCode = product.chart_code;
               this.formData.bankId = product.bank_id;
            }
        },

        computed: {
           getFGTSBalance() {
              return this.clientData.fgtsBalance ? this.clientData.fgtsBalance : 0;
           },
           currentWaLink() {
              let auxPhone;

               if(!this.clientData.mobileNumber) return null;
               
               var match = this.clientData.mobileNumber.match(/^(\d{2})(\d{2})(\d{1})(\d{1})(\d{6})(\d{1})$/)
               if (match) {
                  auxPhone = `${match[2]}${match[3]}${match[4]}${match[5]}${match[6]}`
               }else{
                  let aux = 0;
                  if(this.clientData.mobileNumber.length == 11 && this.clientData.mobileNumber.substr(0, 2) == '55') aux = 2;
                  auxPhone = `${this.clientData.mobileNumber.substr(0+aux)}`
               }

               return "https://wa.me/+55"+auxPhone;
            },

            contractKind () {
                return this.kind || 'EST';
            },

            isBankPayCaixa () {
               return this.formData.paymtAcct && (this.formData.paymtAcct.bankId === 22);
            },

            totalAmount () {
               return parseFloat(this.formData.installment) * parseFloat(this.formData.term);
            },

            multiEnrollment () {
                return (this.clientData && this.clientData.jobs && this.clientData.jobs.length > 1);
            },

            isINSS () {
                return this.formData.selectedEnrollment && (this.formData.selectedEnrollment.covenantId === 1);
            },

            isSIAPE () {
                return this.formData.selectedEnrollment && (this.formData.selectedEnrollment.covenantId === 2);
            },

            isPORTAB () {
                return (Math.trunc(this.formData.typeId / 10) === 3);
            },

            showCovenantExtraFields () {
                return this.isINSS || this.isSIAPE;
            },

            askAcct () {
                if (!this.formData.customerId) return false;

                let en = this.formData.selectedEnrollment;
                let hasAcct = (en.bankId && en.branchNo && en.acctNo);
                let type = +this.formData.paymtType;
                return ((type === 1) && !hasAcct) || (type === 2);
            },

            askLastCTT () {
                return ([2, 3].indexOf(Math.trunc(this.formData.typeId / 10)) >= 0);
            },

            isCard () {
                return ([5, 6].indexOf(Math.trunc(this.formData.typeId / 10)) >= 0);
            },

            isRequired () {
                let isEST = (this.contractKind === 'EST');
                return (isEST && this.toCTT) ? 'required' : '';
            },

            isGtZero () {
                let isEST = (this.contractKind === 'EST');
                return (isEST && this.toCTT) ? 'required,gtZero' : '';
            },

            amountLabel () {
                return (this.isCard) ? 'Valor do Saque' : 'Valor do Contrato';
            },
            acctType() {
               return this.formData.paymtAcct.acctType ? this.formData.paymtAcct.acctType == 'P' ? 'Conta Poupança' : 'Conta Corrente' : '';
            },
            netAmount() {
               return this.formData.amount - this.formData.iofFee - this.formData.tacFee - this.formData.insurance;
            }
        },

        methods: {
            async syncContract(first = false) {
               if (!this.loadingStatusSync && (!first || (this.formData.kind == 'CTT' && this.formData.number))) {
                  this.loadingStatusSync = true;
                  let res = await this.$api.dataService.execute('bank/updateContractStatus', { contractId: this.formData.id, customerId: this.formData.customerId, brandId: this.$store.state.company.brand.id });

                  if (res && res.error) {
                     this.$notifyUser({ 
                        type: 'error', 
                        message: res.error.message 
                     });
                  } else {
                     if (res && res.updated) {
                        let data = await this.$api.dataService.getById('contract', this.formData.id);
                        if (data) {
                           Object.assign(this.formData, data);

                           this.$notifyUser({ 
                              type: 'success', 
                              message: 'Contrato atualizado com sucesso!' 
                           });
                        }
                     } else {
                        this.$notifyUser({ 
                           type: 'error', 
                           message: 'Erro na sincronização!' 
                        });
                     }
                  }

                  this.loadingStatusSync = false;
               }
            },

            getNameBank(value){
               const bank = this.banks.find((e) => e.id == value);
               return bank ? bank.name : "Banco não encontrado";
            },

            openFileModal(url) {
               this.fileSelected = url;
               this.fileModalOpen = true;
            },

            closeFileModal(event) {
               event.preventDefault();
               event.stopPropagation();

               this.fileModalOpen = false;
            },

            async setProposal(value) {
                try { 
                    let data;
                    switch(value) {
                        case "approved": 
                            data = await this.$api.dataService.execute('bank/proposalSetApproved', {customerId: this.formData.customerId, contractId: this.formData.id, bankId: this.formData.bankId});
                            this.$notifyUser({
                                message: 'Sucesso!'
                            });
                            break;
                        case "reproved": 
                            data = await this.$api.dataService.execute('bank/proposalSetReproved', {customerId: this.formData.customerId, contractId: this.formData.id, bankId: this.formData.bankId});
                            this.$notifyUser({
                                message: 'Sucesso!'
                            });
                            break;
                        case "pending": 
                            data = await this.$api.dataService.execute('bank/proposalSetPending', {customerId: this.formData.customerId, contractId: this.formData.id, bankId: this.formData.bankId});
                            this.$notifyUser({
                                message: 'Sucesso!'
                            });
                            break;
                        case "cancelled": 
                            data = await this.$api.dataService.execute('bank/proposalSetCancelled', {customerId: this.formData.customerId, contractId: this.formData.id, bankId: this.formData.bankId});
                            this.$notifyUser({
                                message: 'Sucesso!'
                            });
                            break;
                            case "simulation":
                              this.loadingSimulation = true;
                              try {
                                 data = await this.$api.dataService.execute('contract/simulate', {
                                    customerId: this.formData.customerId,
                                    bankChartCode: this.formData.bankChartCode,
                                    contractId: this.formData.id,
                                    productId: this.formData.productId,
                                    installment: this.formData.installment,
                                    term: this.formData.term,
                                    enrollment: this.formData.enrollment
                                 });

                                 if (data) {
                                    this.loadingSimulation = false;
                                    this.formData.bankStatus = this.formData.bankStatus == null || this.formData.bankStatus === '' ? data.bankStatus : this.formData.bankStatus;
                                    this.formData.statusId = data.statusId;
                                    this.formData.offerLeadId = data.offerLeadId;
                                    this.formData.customerNotes = this.formData.customerNotes == null || this.formData.customerNotes === '' ? data.customerNotes : this.formData.customerNotes;
                                    this.formData.iofFee = data.iofFee;
                                    this.formData.apiError = data.apiError;
                                    this.formData.typeId = data.typeId;
                                    this.formData.term = data.term;
                                    this.formData.amount = data.financedAmount;
                                    this.formData.finalAmount = data.grossAmount;
                                    this.formData.netAmount = data.netAmount;
                                    this.formData.installment = data.installment;
                                    this.formData.interest = data.interest;
                                    this.formData.tacFee = data.tacFee;
                                    this.formData.insurance = data.insuranceFee;
                                    this.formData.simulationId = data.simulationId;

                                    this.$notifyUser({
                                    type: 'success',
                                    message: 'Simulação finalizada'
                                    });

                                    this.$api.dataService.save('contract', {
                                       statusIdAt: this.formData.statusIdAt,
                                       paymtAcct: this.formData.paymtAcct,
                                       createdAt: this.formData.createdAt,
                                       typeId: this.formData.typeId,
                                       bankId: this.formData.bankId,
                                       amount: this.formData.amount,
                                       term: this.formData.term,
                                       netAmount: this.formData.netAmount
                                     }, this.formData.id).then(() => {

                                       this.$notifyUser({
                                       type: 'success',
                                       message: 'Contrato Simulado e Salvo!'
                                       });

                                     });


                                 }
                              } catch (error) {

                                 console.error('Erro na simulação:', error);
                                 this.$notifyUser({
                                    type: 'error',
                                    message: 'Erro na simulação. Por favor, tente novamente mais tarde.'
                                 });
                              }

                              break;
                        case "add":
                            this.isLoadingProposal = true;
                            data = await this.$api.dataService.execute('contract/addProposal', 
                              
                              {
                                 customerId: this.formData.customerId, 
                                 contractId: this.formData.id
                              });

                              if (data) {

                                 this.isLoadingProposal = false;
                                 this.dialogContract = false;

                                 this.formData.formalizationLink = data.formalizationLink;
                                 this.formData.number = data.number;
                                 this.formData.issueDate = data. issueDate;
                                 this.formData.bankStatus = data.bankStatus;
                                 this.formData.iofFee = data.iofFee;
                                 this.formData.apiError = data.apiError;
                                 this.formData.term = data.term;
                                 this.formData.amount = data.amount;
                                 this.formData.finalAmount = data.finalAmount;
                                 this.formData.netAmount = data.netAmount;
                                 this.formData.installment = data.installment;
                                 this.formData.interest = data.interest;
                              }

                            break;
                        default:
                            this.$notifyUser({
                                type: "error",
                                message: 'Nenhuma opção selecionada!'
                            });
                            break;
                     }

                     let update = await this.$api.dataService.getById('contract', this.formData.id);
                     if (update) {
                        
                        if(value != 'simulation'){
                           Object.assign(this.formData, update);

                           this.$notifyUser({ 
                              type: 'success', 
                              message: 'Operação Finalizada!'
                           });
                        }

                        this.loadingSimulation = false;
                     }
                } catch(e) {
                    this.loadingSimulation = false;
                    this.isLoadingProposal = false;
                    this.dialogContract = false;

                    this.$notifyUser({
                        type: "error",
                        message: 'Erro '
                    });
                }
            },

           	copyText(text, event) {
               event.preventDefault();
               event.stopPropagation();

               window.Clipboard.copy(text);

               this.$notifyUser({
                  message: 'Texto Copiado!'
               });
            },

            async getFormalizationLink() {
               if ([12,13,14,19,28,53].includes(this.formData.statusId)) {
                  this.$notifyUser({
                     type: "error",
                     message: 'Não é possível formalizar esse contrato!'
                  });
               } else if (this.formData.number) {
                  let data = await this.$api.dataService.execute('bank/getContractFormalizationLink', { contractId: this.formData.id, customerId: this.formData.customerId });
                  if (!data) {
                     this.$notifyUser({
                        type: "error",
                        message: 'Não foi possível obter o link de formalização.'
                     });
                  } else {
                     this.formData.formalizationLink = data.formalization;
                  }
               } else {
                  this.$notifyUser({
                     type: "error",
                     message: 'Esse contrato não possui número!'
                  });
               }
            },

            async setAmount() {
               if (this.formData.chartId) {
                  this.loadingAmount = true;
                  try {
                     if (this.formData.term) {
                        let data = await this.$api.dataService.execute('bankChart/getByIdAndTerm', { chartId: this.formData.chartId, term: this.formData.term });

                        if (data) {
                           this.formData.amount = this.formData.typeId == 20 || this.formData.typeId == 30 ? 
                              (this.formData.installment / parseFloat(data.factor)) - this.formData.originalCttData.balanceDue :
                              (this.formData.installment / parseFloat(data.factor));
                        } else {
                           this.$notifyUser({
                              type: 'error',
                              message: 'Nenhuma tabela de fator encontrada.'
                           }); 
                        }
                     } else {
                        this.$notifyUser({
                           type: 'error',
                           message: 'preencha o Prazo Total para o cálculo automático do valor do contrato.'
                        });   
                     }

                     this.loadingAmount = false;
                  } catch (e) {
                     this.$notifyUser({
                        type: 'error',
                        message: 'Erro ao calcular valor do contrato.'
                     });

                     this.loadingAmount = false;
                  }
               }
            },

            saveConfirmation(data){
               return new Promise((resolve, reject) => {
                  if(this.formData.selectedEnrollment.id){
                     if(data.selectedEnrollment){
                        data.selectedEnrollment.id = this.formData.selectedEnrollment.id
                     }else{
                        if(data.paymtAcct){
                           data.selectedEnrollment = {
                              id: this.formData.selectedEnrollment.id
                           }
                        }
                     }
                  }
                  resolve(true)
               });
            },
            renewEnrollmentId(){
               if(this.formData.selectedEnrollment.id){
                  if(typeof this.formData.selectedEnrollment.id == 'string'){
                     this.formData.selectedEnrollment.id = parseInt(this.formData.selectedEnrollment.id)
                  }else{
                     this.formData.selectedEnrollment.id = this.formData.selectedEnrollment.id.toString();
                  }
               }
            },
            async onChangeBankChartCode(data){
               if(this.$refs.aafBankChart && this.$refs.aafBankChart.items && this.$refs.aafBankChart.items.length){
                  let auxBankChart = this.$refs.aafBankChart.items.find(el => el.code == data);
                  if(auxBankChart && auxBankChart.id)this.formData.chartId = auxBankChart.id;
               }
            },
            onBankSelect(data){
               this.isBankChartCodeRequired = data && data.hasBankApi ? 'required' : '';
            },
            onBankChartSelect(data){
               let bankChartCode = data.code;
               if(this.formData.bankChartCode != bankChartCode) this.formData.bankChartCode = bankChartCode;
            },
            async onClientSelect (data) {
               this.clientData = await this.$api.dataService.getById('client', data.id);
               if(!this.formData.id && this.clientData.paymtAcct && Object.keys(this.clientData.paymtAcct).length){
                  data = JSON.parse(JSON.stringify(this.clientData.paymtAcct));
                  let { bankId, bankNo, branchNo, acctNo, acctType } = data;
                  this.formData.paymtAcct = {
                     bankId,
                     bankNo,
                     branchNo,
                     acctNo,
                     acctType
                  };
               }

                if (this.clientData && Array.isArray(this.clientData.jobs)) {
                  let newEnrollment;
                  if(this.formData.enrollmentId)
                     newEnrollment = this.clientData.jobs.find(el => el.id == this.formData.enrollmentId)
                  if(!newEnrollment)
                     newEnrollment = this.clientData.jobs[0];

                  this.formData.enrollmentsFile = [{
                     enrollment: 'Geral',
                     file: this.clientData.file,
                     filesPdf: this.clientData.filesPdf
                  }];
                  this.formData.enrollmentsFile = [...this.formData.enrollmentsFile, ...this.clientData.enrollmentsFile]

                  this.formData.covenantId = newEnrollment.covenantId;
                  this.salaryBankName = newEnrollment.salaryBankName;
                  this.formData.selectedEnrollment = newEnrollment;
                  this.enrollmentChange(newEnrollment);
                  // this.formData.paymtType = 1;
                }
            },

            async onEnrollmentSelect(data){
               let enrollmentId = data.id || this.formData.enrollmentId;
               this.clientData = await this.$api.dataService.getById('client', this.formData.customerId);
                if (this.clientData && Array.isArray(this.clientData.jobs)) {
                  let newEnrollment = this.clientData.jobs.find(el => el.id == enrollmentId)
                  this.salaryBankName = newEnrollment.salaryBankName;
                  this.formData.selectedEnrollment = newEnrollment;
                  this.enrollmentChange(newEnrollment);
                }
            },

            enrollmentChange (data) {
               this.formData.enrollment = data.enrollment;
               this.formData.enrollmentId = data.id;
            },
            bankPayChange (value){
               this.salaryBankName = `${value.bankNo} - ${value.name}`;
               if(value.id !== 22){
                  this.auxBankPayOpNo = this.formData.paymtAcct.opNo;
                  this.formData.paymtAcct.opNo = null;
               }else{
                  this.formData.paymtAcct.opNo = this.auxBankPayOpNo;
               }
            },
            inssPayChange (value) {
                if (value === 2 && this.formData.paymtAcct) {
                    this.formData.paymtAcct.acctNo = null;
                } else if (value === 1 && this.formData.paymtAcct && this.formData.selectedEnrollment) {
                    this.formData.paymtAcct.acctNo = this.formData.selectedEnrollment.acctNo;
                }
            },

            editClient () {
                this.$refs.aafClient.editRecord(this.formData.customerId);
            },

            cloudinaryUpload (url, unsignedUploadPreset) {
                return ({
                    process: (fieldName, file, metadata, load, error, progress, abort) => {

                        const xhr = new XMLHttpRequest();
                        const formData = new FormData();

                        xhr.open('POST', url, true);
                        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                        xhr.upload.addEventListener('progress', e => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        });
                        xhr.onreadystatechange = e => {
                            if (xhr.readyState !== 4) {
                                return;
                            }
                            if (xhr.status >= 200 && xhr.status < 300) {
                                const response = JSON.parse(xhr.responseText);
                                const file = response.public_id;
                                this.$api.dataService.postData('appUser/saveDocuments', { customerId: this.formData.customerId,
                                    file: {
                                       file,
                                       format: response.format,
                                       type: response.resource_type,
                                       width: response.width,
                                       height: response.height
                                    },
                                    typeId: 6
                                });
                                load(response.file);
                                return;
                            }

                            error('oh no!');
                        };

                        formData.append('upload_preset', unsignedUploadPreset);
                        formData.append('tags', 'browser_upload');
                        formData.append('file', file);
                        xhr.send(formData);

                        return {
                            abort: () => {
                                xhr.abort();
                            }
                        };
                    },
                    revert: null
                });
            },

            toggleExpansion(event) {
               if (event.target.classList.contains('expansion-header')) {
                  if (event.target.parentNode.classList.contains('expanded')) event.target.parentNode.classList.remove('expanded');
                  else event.target.parentNode.classList.add('expanded');
               } else {
                  if (event.target.parentNode.parentNode.classList.contains('expanded')) event.target.parentNode.parentNode.classList.remove('expanded');
                  else event.target.parentNode.parentNode.classList.add('expanded');
               }
            },

            beforeSave() {
               this.formData.number = this.formData.numberField;
            }
         },

         async created() {
            this.products = this.filteredProducts = await this.$api.dataService.search('products');
            this.covenantList = await this.$api.dataService.search('covenant');
            this.syncContract(true);
         }
    });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .file-content-one {
      width: 100%;
      background-color: #EFEFEF;
      padding: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
      color: orange;
   }

   .file-content {
      width: 100%;
      background-color: #f3f3f3;
      padding: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      border-radius: 5px;
   }

   .file-content:last-child {
      margin-bottom: 15px !important;
   }

   .file-content > div {
      display: flex;
      align-items: center;
   }

   .file-content > div > p {
      margin: 0 0 0 10px;
      font-size: 16px;
      font-weight: bold;
   }

   .file-container {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      background-color: #000000be;
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
   }

   .file-container > iframe {
      width: 80%;
      height: 90%;
   }

   .file-container > .btn-file-close {
      position: absolute;
      top: 22px;
      right: 50px;
   }

   /* .filepond--panel-root {
      background: #ffffff !important;
      border-radius: 10px;
      opacity: 100% !important;
      z-index: 100000
   }  */

   .expansion {
      background-color: #FFF;
      border-radius: 0;
   }

   .expansion-header {
      transition: .2s;
      padding: 10px 15px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
   }

   .expansion-header > h3 {
      font-size: 18px;
      font-weight: bold;
      color: #262626;
   }

   .expansion-header > i {
      color: #262626;
   }

   .expansion.expanded .expansion-header > i {
      color: #FFF;
      transform: rotate(-90deg);
   }

   .expansion.expanded .expansion-header > h3 {
      color: #FFF;
   }

   .expansion.expanded .expansion-header {
      background-color: #4744e9;
   }

   .expansion-body {
      padding: 0 15px;
      overflow: hidden;
      transition: .2s;
      height: 0;
   }

   .expansion.expanded .expansion-body {
      padding: 10px 15px;
      height: auto;
   }

   .sync-box {
      width: 45px;
      height: 45px;
      margin-right: 25px;
      border-radius: 100%;
      background-color: #D4FFCA;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: none;
      cursor: pointer;
      align-self: center;
      box-shadow: 0 2px 3px 0 rgba(0,0,0,0.15);
   }

   .sync-box > i {
      font-size: 30px;
      color: #3BAD1E;
   }

   .spinning {
      animation-name: spin;
      animation-duration: 1000ms;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out; 
   }

   .red-text {
      color: #e94343;
      font-weight: bold;
   }

   .normal-text {
      color: #262626;
   }

   .v-input__slot {
      background-color: #e0e0e0 !important;
   }

   @keyframes spin {
      from {
         transform:rotate(0deg);
      }
      to {
         transform:rotate(-360deg);
      }
   }
</style>



// WEBPACK FOOTER //
// src/pages/ContractForm.vue